import { all, call, put, takeLatest } from 'redux-saga/effects';

import { fetchEncodedData } from '../../../utility/requests';

import actionCreators from './actionCreators';
import actionTypes from './actionTypes';

function* gameShifts({ payload }) {
    try {
        const excludes = ['detailCode', 'duration', 'eventDetails', 'teamAbbrev', 'teamName']
            .map((e) => `&exclude=${e}`)
            .join('');

        const { gameId } = payload;
        const shiftCode = 517;
        const [shiftData, gameData] = yield all([
            call(
                fetchEncodedData,
                `${window.__BASE_REST_URL__}/shiftcharts?cayenneExp=gameId=${gameId} and ((duration != '00:00' and typeCode = ${shiftCode}) or typeCode != ${shiftCode} )${excludes}`,
            ),
            call(fetchEncodedData, `${window.__BASE_REST_URL__}/game?cayenneExp=id=${gameId}&include=gameFormat`),
        ]);

        const teamIds = [];
        shiftData.data.forEach((shift) => {
            if (!teamIds.includes(shift.teamId)) {
                teamIds.push(shift.teamId);
            }
        });

        const [team1Data, team2Data] = yield all([
            call(fetchEncodedData, `${window.__BASE_REST_URL__}/team/id/${teamIds[0]}?include=logos`),
            call(fetchEncodedData, `${window.__BASE_REST_URL__}/team/id/${teamIds[1]}?include=logos`),
        ]);
        const teams = [...team1Data.data, ...team2Data.data];

        yield put(actionCreators.gameShiftsResponse(true, null, shiftData.data));
        yield put(actionCreators.teamDataResponse(true, null, teams));
        yield put(actionCreators.gameResponse(true, null, gameData.data[0]));
    } catch (errors) {
        yield put(actionCreators.gameShiftsResponse(false, errors, null));
    }
}

export default function* watchShiftCharts() {
    yield takeLatest(actionTypes.REQUEST_GAME_SHIFTS, gameShifts);
}
